// ** Reducers Imports
import auth from "./auth";
import breadcum from "./breadcrumb.js";

const rootReducer = { auth, breadcum };

export default rootReducer;
